import React, { useEffect, useState } from 'react';
import './collaborators.css'
import client from '../../utils/prismicHelpers';
import * as queries from "../../utils/prismicQueries";
import BrandLogo from './BrandLogo';
import BreadCrumb from '../../main/components/BreadCrumb';
import PartnerTiresCard from './PartnerTiresCard';
import WorkingStage from './WorkingStage';

const Collaborators = () => {
    const [collaborators, setCollaborator] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.collaborator,
            })
            .then((response) => {
                const collaboratorDoc = response.data.allCollaboratorss.edges[0].node;
                setCollaborator(collaboratorDoc);
                window.scrollTo(0, 0)
            })
            .catch((error) => {
                console.error(error);
            });
    });

    return (
        <section style={{ backgroundImage: `url(${collaborators?.section_bg?.url})` }} className='news-container '>
            <div className="container collaborators-container">
                <BreadCrumb nested={"Partners & Collaborators"} />
                <h3 className="subtitle">{"Partners & Collaborators"}</h3>
                <div className="brand-container">
                    <div className="row g-3">
                        {collaborators?.brand?.map((brand, index) => <BrandLogo key={index} brandImg={brand} />)}
                    </div>
                </div>
                <div className=" pt-5">
                    <h5 className='subtitle   mb-0'>{collaborators?.tires_title}</h5>
                    <p>{collaborators?.tires_des}</p>
                    <div className="partner-tires pt-3">
                        <div className="row g-3">
                            {collaborators?.tiers?.map((tiersInfo, index) => <PartnerTiresCard key={index + 1} tiersInfo={tiersInfo} />)}
                        </div>
                    </div>
                </div>
                <div className=" work-criteria-box my-5">
                    <h5 className='subtitle   text-center'>{collaborators?.ways_title}</h5>

                    <div className="row  mt-3 gy-4">
                        {collaborators?.ways?.map((waysInfo, index) => <WorkingStage key={index + 1} sl={index + 1} waysInfo={waysInfo} />)}

                    </div>
                </div>
                <h3 className="reaching-email">{collaborators?.email_text.slice(0, 12)}
                    <a
                       
                        target="_blank"
                        href={"mailto:" + collaborators?.email_text.slice(12, 100)}
                    >
                        {collaborators?.email_text.slice(12, 100)}
                    </a>
                </h3>

            </div>
        </section>
    );
};

export default Collaborators;